(function () {
  'use strict';

  function initCarousels(root) {
    function findAll(scope, selector) {
      var matches = Array.from(scope.querySelectorAll(selector));
      if (scope.matches && scope.matches(selector)) matches.unshift(scope);
      return matches;
    }

    findAll(root || document, '[data-promo-carousel]').forEach(function (carousel) {
      if (carousel.dataset.carouselReady === 'true') return;
      var track = carousel.querySelector('[data-carousel-track]');
      var previous = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      if (!track) return;
      carousel.dataset.carouselReady = 'true';

      function scrollByCard(direction) {
        var card = track.firstElementChild;
        var distance = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
        track.scrollBy({ left: distance * direction, behavior: 'smooth' });
      }

      if (previous) previous.addEventListener('click', function () { scrollByCard(-1); });
      if (next) next.addEventListener('click', function () { scrollByCard(1); });
    });
    findAll(root || document, '[data-promo-products-carousel]').forEach(function (carousel) {
      if (carousel.dataset.carouselReady === 'true') return;
      var track = carousel.querySelector('[data-promo-products-track]');
      if (!track) return;
      carousel.dataset.carouselReady = 'true';
      var controlScope = carousel.parentElement || carousel;
      var buttons = controlScope.querySelectorAll('[data-promo-products-prev], [data-promo-products-next]');
      function updateButtons() {
        var max = Math.max(0, track.scrollWidth - track.clientWidth - 2);
        controlScope.querySelectorAll('[data-promo-products-prev]').forEach(function (button) { button.disabled = track.scrollLeft <= 2 || max <= 2; });
        controlScope.querySelectorAll('[data-promo-products-next]').forEach(function (button) { button.disabled = track.scrollLeft >= max || max <= 2; });
      }
      function scrollProducts(direction) {
        var card = track.firstElementChild;
        var gap = parseFloat(getComputedStyle(track).gap) || 0;
        var step = (card ? card.getBoundingClientRect().width + gap : track.clientWidth * .8);
        var max = Math.max(0, track.scrollWidth - track.clientWidth);
        var target = Math.max(0, Math.min(max, track.scrollLeft + step * direction));
        track.scrollTo({ left: target, behavior: 'smooth' });
      }
      buttons.forEach(function (button) { button.addEventListener('click', function () { scrollProducts(button.hasAttribute('data-promo-products-next') ? 1 : -1); }); });
      var updateFrame = 0;
      function scheduleButtonUpdate() {
        if (updateFrame) return;
        updateFrame = requestAnimationFrame(function () {
          updateFrame = 0;
          updateButtons();
        });
      }
      track.addEventListener('scroll', scheduleButtonUpdate, { passive: true });
      if ('ResizeObserver' in window) {
        new ResizeObserver(scheduleButtonUpdate).observe(track);
      } else {
        window.addEventListener('resize', scheduleButtonUpdate);
      }
      updateButtons();
    });

    findAll(root || document, '[data-promo-product-card]').forEach(function (card) {
      if (card.dataset.variantPickerReady === 'true') return;
      card.dataset.variantPickerReady = 'true';

      card.querySelectorAll('[data-promo-variant-swatch]').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          var variantId = swatch.dataset.variantId;
          if (!variantId) return;

          // Keep Intelligems price identity in sync before updating the displayed price.
          card.dataset.variantId = variantId;
          card.querySelectorAll('.promo-home-product__price, [data-promo-product-price], [data-promo-product-compare]').forEach(function (element) {
            element.dataset.variantId = variantId;
          });

          card.querySelectorAll('[data-promo-variant-swatch]').forEach(function (item) {
            var selected = item === swatch;
            item.classList.toggle('is-selected', selected);
            item.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });

          var color = card.querySelector('[data-promo-selected-color]');
          if (color) color.textContent = swatch.dataset.color || '';

          var image = card.querySelector('.promo-home-product__media > img:not(.promo-home-product__secondary-image)');
          if (image && swatch.dataset.imageUrl) {
            image.src = swatch.dataset.imageUrl;
            image.removeAttribute('srcset');
            image.alt = swatch.dataset.imageAlt || '';
          }

          card.querySelectorAll('[data-promo-product-link]').forEach(function (link) {
            link.href = swatch.dataset.productUrl;
          });

          var price = card.querySelector('[data-promo-product-price]');
          if (price) price.textContent = swatch.dataset.price || '';
          var compare = card.querySelector('[data-promo-product-compare]');
          var discount = Number(swatch.dataset.discount || 0);
          if (compare) {
            compare.textContent = swatch.dataset.comparePrice || '';
            compare.hidden = discount <= 0;
          }
          var badge = card.querySelector('[data-promo-product-badge]');
          var badgeText = card.querySelector('[data-promo-product-discount]');
          if (badge) badge.style.display = discount > 0 ? '' : 'none';
          if (badgeText) badgeText.textContent = discount + '% off';

          var input = card.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
          var button = card.querySelector('.promo-home-product__link');
          if (input) {
            input.value = variantId;
            input.setAttribute('value', variantId);
          }
          if (button) button.dataset.variantId = variantId;
          if (input) input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  var pendingSections = new WeakSet();
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      initCarousels(entry.target);
    });
  }, { rootMargin: '100px 0px' }) : null;

  function scheduleSections(root) {
    root.querySelectorAll('[data-promo-background]').forEach(function (section) {
      if (!backgroundObserver || window.Shopify?.designMode) {
        section.removeAttribute('data-promo-background');
      } else {
        backgroundObserver.observe(section);
      }
    });
    if (!observer || window.Shopify?.designMode) {
      initCarousels(root);
      return;
    }
    var sections = new Set();
    root.querySelectorAll('[data-promo-carousel], [data-promo-products-carousel]').forEach(function (carousel) {
      sections.add(carousel.closest('.shopify-section') || carousel.parentElement);
    });
    sections.forEach(function (section) {
      if (pendingSections.has(section)) return;
      pendingSections.add(section);
      observer.observe(section);
      // Keyboard focus and quick pointer interaction must work before IO fires.
      function activate() {
        observer.unobserve(section);
        initCarousels(section);
        section.removeEventListener('pointerdown', activate, true);
        section.removeEventListener('focusin', activate, true);
      }
      section.addEventListener('pointerdown', activate, true);
      section.addEventListener('focusin', activate, true);
    });
  }

  var backgroundObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.removeAttribute('data-promo-background');
      backgroundObserver.unobserve(entry.target);
    });
  }, { rootMargin: '400px 0px' }) : null;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scheduleSections(document); });
  } else {
    scheduleSections(document);
  }
  document.addEventListener('shopify:section:load', function (event) { scheduleSections(event.target); });
})();
